// extracted by mini-css-extract-plugin
module.exports = {"phoneNumbersWrapper":"PhoneNumbersForm_phoneNumbersWrapper__GH-0Q","formsControlsWrapper":"PhoneNumbersForm_formsControlsWrapper__xc9EW"};